<template>
  <div class="drug-venue" v-track-page="'yd_category'">
    <div class="search-contain">
      <search class="nav-search" @search="searchFocus" @cancel="searchCancel" />
      <CartIcon @onClick="pageToRequestCart" :cartCountTrolley="cartCountTrolley" />
    </div>

    <div class="container">
      <div class="content">
        <section v-if="(orderList || []).length">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多药品了" @load="onLoad">
            <ProductItem
              v-for="(item, key) in orderList"
              @changeGoodsAmount="getCartCountTrolley"
              :hasCoupon="true"
              :showBorder="showSiderbar"
              :item="item"
              :key="key.itemId"
              :fly-button="true"
            />
          </van-list>
        </section>
        <van-empty
          class="empty-margin"
          v-else-if="finished"
          description="暂无商品"
          image="//static.91jkys.com/attachment/20211021101256064_c7a906b021bc4f839e3e9fd8c02c9236.png"
        ></van-empty>
      </div>
      <!-- <div class="reques-cart flex center" @click="pageToRequestCart">
        <span v-if="requestCount" class="request-count"></span>
        <img
          src="//static.91jkys.com/third_files/GuoYao/202009/28/7f05a7d88d334dc2ba14ca93b2428bba.png"
          class="img"
          id="buycar"
          alt=""
        />
      </div> -->
    </div>
  </div>
</template>
<script>
import Search from './components/searchCoupon';
import ProductItem from '@/components/ProductItem.vue';
import { CartIcon } from '@/components/search/index.js';
export default {
  components: { Search, ProductItem, CartIcon },
  data() {
    return {
      showSiderbar: false, // 是否显示siderbar
      orderList: [], // 商品列表
      category: [], // 商品类目列表
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 20,
      currentCatId: null, // 当前选取类目的id
      keyWord: '', // 当前用户所输入关键字
      requestCount: 0, // 当前需求清单所显示数量
      canClick: true,
      couponId: '',
      cartCountTrolley: null,
      startIndex: 0
    };
  },
  async created() {
    this.couponId = this.$route.query.couponId || '';
    await this.onLoad();
    // 获取需求清单数量
    this.fetchCountTrolley();

    this.getCartCountTrolley();
  },
  methods: {
    async fetchCountTrolley() {
      const { amount = 0 } = await this.$fetch.fetchCountTrolley();
      this.requestCount = amount;
    },
    searchCancel() {
      // this.currentCatId = this.category[0].id;
      this.keyWord = '';
      this.pageNo = 1;
      this.startIndex = 0;
      this.finished = false;
      this.onLoad();
    },
    searchFocus(val) {
      this.pageNo = 1;
      this.startIndex = 0;
      this.finished = false;
      this.keyWord = val;
      this.onLoad();
    },
    changeCategory(index) {
      // 这里是用户事件触发 其实是没有报错风险的
      if (this.category.length) this.currentCatId = this.category[index].id;
      this.pageNo = 1;
      this.startIndex = 0;
      this.finished = false;
      this.onLoad();
    },
    async fetchData() {
      if (this.pageNo === 1) {
        this.orderList = [];
      }
      const params = {
        couponId: this.couponId,
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        startIndex: this.startIndex
      };
      params.keyWord = this.keyWord;

      try {
        const { list = [], hasMore, startIndex = 0 } = await this.$fetch.getItemListByCoupon(params);
        this.startIndex = startIndex;
        // 兼容性问题
        if (this.pageNo === 1) {
          this.orderList = list;
        } else {
          this.orderList.push(...list);
        }

        if (!hasMore) {
          this.finished = true;
        }
      } catch (err) {
        this.canClick = true;
      }
    },
    async onLoad() {
      await this.fetchData();
      this.loading = false;
      this.pageNo += 1;
    },
    pageToRequestCart() {
      this.$router.push({ name: 'requestCart' });
    },
    getCartCountTrolley() {
      this.$fetch.getCartCountTrolley().then((res) => {
        this.cartCountTrolley = res?.amount || null;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.drug-venue {
  position: relative;
  width: 100%;
  // overflow-x: hidden;
  .search-contain {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 49px;
    background: #fff;
    z-index: 4;
    padding-right: 12px;
  }
  .nav-search {
    flex: 1;
    ::v-deep .van-search__content--round {
      border-radius: 22px;
    }
    ::v-deep .van-search {
      height: 49px !important;
      padding-right: 0;
      .van-field__left-icon {
        position: relative;
        top: -3px;
      }
    }
  }
  .siderbar {
    width: 79px;
    min-width: 79px;
    overflow-x: hidden;
    position: fixed;
    z-index: 3;
    top: 49px;
    left: 0;
    height: calc(100vh - 49px);

    background: #f7f8fa;
    overflow-y: auto;
  }
  .container {
    &.showSiderbar {
      padding-left: 79px;
    }
    padding-top: 49px;
    width: 100%;
  }

  .content {
    min-height: calc(100vh - 49px);
    width: 100%;
    padding-top: 4px;
    padding-left: 4px;
    background: #fff;
    .empty-margin {
      margin-top: 64px;
    }
    ::v-deep .van-list {
      background: #fff !important;
    }
  }

  .reques-cart {
    .request-count {
      display: inline-block;
      position: absolute;
      top: 2px;
      right: -2px;
      width: 12px;
      height: 12px;
      background: #fa4b4b;
      border-radius: 12px;
    }
    position: fixed;
    right: 12px;
    bottom: 20px;
    z-index: 5;
    width: 48px;
    height: 48px;
    border-radius: 48px;
    background: #ffffff;
    box-shadow: 0px 4px 12px 0px rgba(38, 38, 38, 0.2);
    .img {
      width: 25px;
      height: 25px;
    }
  }
  ::v-deep .van-list__finished-text {
    font-size: 14px;
    color: #8c8c8c;
  }
}

@keyframes mymove {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(0.6);
  }
  75% {
    transform: scale(0.4);
  }
  100% {
    transform: scale(0.2);
  }
}
.moveToCart {
  animation: mymove 0.5s ease-in-out;
}
</style>
